import { defineStore } from 'pinia';
import { ref } from 'vue';

// Pinia port of the customer-apps BadgeService: a keyed map of reactive counters.
// Used by the invoice unread badge — UserMenu seeds it (countUnread), InvoiceListItem
// decrements it once an unread invoice has been previewed (markAsRead).
export const useBadgeStore = defineStore('badge', () => {
    const counters = ref<Record<string, number>>({});

    function getCounter(key: string): number {
        return counters.value[key] ?? 0;
    }

    function setCounter(key: string, value: number): void {
        counters.value[key] = value;
    }

    function incrementCounter(key: string): void {
        counters.value[key] = getCounter(key) + 1;
    }

    function decrementCounter(key: string): void {
        counters.value[key] = getCounter(key) - 1;
    }

    function resetCounter(key: string): void {
        counters.value[key] = 0;
    }

    return { counters, getCounter, setCounter, incrementCounter, decrementCounter, resetCounter };
});
